import { defineMessages } from 'react-intl';

export default defineMessages({
    billingTitle: {
        id: 'ri.billing.views.billing-landing.title.Billing Information',
        defaultMessage: 'Billing Information'
    },  
    transactions: {
        id: 'ri.billing.views.billing-landing.Transactions',
        defaultMessage: 'Transactions'
    },
    transactionsTitle: {
        id: 'ri.billing.views.transactions.title.Account Transactions',
        defaultMessage: 'Account Transactions'
    },
    documents: {
        id: 'ri.billing.views.billing-landing.Invoices',
        defaultMessage: 'Invoices'
    },
    documentsTitle: {
        id: 'ri.billing.views.documents.title.Invoices',
        defaultMessage: 'Invoices'
    },
    summary: {
        id: 'ri.billing.views.billing-landing.Summary',
        defaultMessage: 'Summary'
    },    
    status: {
        id: 'ri.billing.views.billing-landing.Status',
        defaultMessage: 'Status'
    },
    policyNumber: {
        id: 'ri.billing.views.billing-landing.Policy Number',
        defaultMessage: 'Policy Number'
    },
    billingTerms: {
        id: 'ri.billing.views.billing-landing.Policy Terms',
        defaultMessage: 'Policy Terms'
    },
    claimNumber: {
        id: 'ri.billing.views.billing-landing.Claim Number',
        defaultMessage: 'Claim Number'
    },
    noResultFound: {
        id: 'ri.billing.views.claims-landing.No results found for this filter',
        defaultMessage: 'No results were found for this filter.'
    },
    accountTermsNavigation: {
        id: 'gateway.navigation.breadcrumbs.Account:Account', 
        defaultMessage: '({link})'
    },
    billingDelivery: {
        id: 'ri.billing.views.billing-landing.Billing Delivery',
        defaultMessage: 'Billing Delivery'
    },
    insuredName: {
        id: 'ri.billing.views.documents.title.Insured Name:',
        defaultMessage: 'Insured Name:'
    }

});